import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reusable Breadcrumb Component
 * @param {Array} items - Array of { label, path, onClick? } objects
 *   - onClick: optional click handler, makes item clickable even if it's the last item
 */
const Breadcrumb = ({ items }) => {
  const breadcrumbStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '0.875rem',
    color: '#495057',
    marginBottom: '1.5rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #dee2e6'
  };

  const linkStyle = {
    color: '#667eea',
    textDecoration: 'none',
    fontWeight: '500',
    cursor: 'pointer'
  };

  const separatorStyle = {
    color: '#6c757d'
  };

  const currentStyle = {
    color: '#495057',
    fontWeight: '500'
  };

  const handleClick = (item, e) => {
    if (item.onClick) {
      e.preventDefault();
      item.onClick();
    }
  };

  return (
    <nav style={breadcrumbStyle} aria-label="breadcrumb">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span style={separatorStyle}>›</span>}
          {index === items.length - 1 && !item.onClick ? (
            <span style={currentStyle}>{item.label}</span>
          ) : (
            <Link
              to={item.path}
              style={linkStyle}
              onClick={(e) => handleClick(item, e)}
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
